"use client";

import { cn } from "@/lib/utils";
import { PictureUpload } from "@/components/common/picture-upload/picture-upload";
import { ImageHoverWrapper } from "@/components/common/image-hover-wrapper";
import { SuperLink as Link } from "@/components/common/super-link";
import { createPath } from "@/service/routing/routing";
import { PriceLink } from "@/components/ecommerce/price-link";

export const EbookCard = ({
  ebook,
  onClick = () => {},
  aside = false,
}: {
  ebook: EbookPreviewVM;
  onClick?: () => void;
  aside?: boolean;
}) => {
  const { image, name, product, slug } = ebook;
  const link = createPath("ebook.show", { slug });
  return (
    <div
      className={cn(
        "group mx-auto flex max-w-[300px] flex-col gap-4",
        aside && "w-full flex-row self-stretch",
      )}
    >
      <ImageHoverWrapper
        rounded={cn("rounded-xl", aside && "rounded-lg")}
        className={cn(aside && "min-w-[129px]")}
      >
        <Link href={link} onClick={onClick}>
          <PictureUpload
            image={image}
            aspectRatio="3 / 4"
            loaded={true}
            className={cn("w-full", aside && "w-[129px] min-w-[129px]")}
            type={"card"}
          />
        </Link>
      </ImageHoverWrapper>

      <div className={cn("flex flex-col gap-1.5", aside && "justify-center")}>
        <Link href={link} onClick={onClick}>
          <p
            className={cn(
              "hover:text-remedium-blue text-base font-[550] transition-colors",
              aside && "text-sm",
            )}
          >
            {name}
          </p>
        </Link>
        {product && <PriceLink product={product} link={link} />}
      </div>
    </div>
  );
};
